module.exports = __webpack_public_path__ + "assets/img/sad-active.fa87c0f9.svg";